import { PermissionKey } from '@client/api';
import { useUserPermission } from '../../hooks/useUserPermission/useUserPermission';
import { Button, ButtonProps, InfoTooltip } from '@client/toolkit';

export interface PermissionBasedActionButtonProps extends Omit<ButtonProps, 'ref'> {
  permissions: PermissionKey[];
  title?: string;
  disabledTooltip?: string;
}

export function PermissionBasedActionButton({
  onClick,
  permissions,
  title,
  children,
  color = 'primary',
  size = 'sm',
  disabledVariant = 'dark',
  disabled,
  disabledTooltip,
  ...props
}: PermissionBasedActionButtonProps) {
  const { hasAnyPermission } = useUserPermission();
  if (!hasAnyPermission(permissions)) return null;

  const button = (
    <Button color={color} size={size} disabledVariant={disabledVariant} disabled={disabled} onClick={onClick} {...props}>
      {title ?? children}
    </Button>
  );

  if (disabled && disabledTooltip) {
    return (
      <InfoTooltip message={disabledTooltip} inline>
        <span>{button}</span>
      </InfoTooltip>
    );
  }

  return button;
}
